import React, { useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import {
  InvitedOrganizationMember,
  useAcceptInvitation,
  useMe,
} from '@app/api';
import { useTranslation } from 'react-i18next';
import { Button, useToast } from '@app/core';
import { LoginContent } from '../../../components/LoginModal/LoginContent';
import { useLocale } from '@app/i18n';

const useStyles = createUseStyles((theme: Theme) => ({
  h2: {
    ...theme.fonts.h3,
    marginBottom: theme.marginBase * 3,
  },
  question: {
    ...theme.fonts.body,
  },
  buttonLine: {
    marginTop: theme.marginBase * 3,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.marginBase * 2,
  },
}));

interface Props {
  invitation: InvitedOrganizationMember;
  token: string;
}
export const JoinOrganizationPage = ({ invitation, token }: Props) => {
  const classes = useStyles();
  const toast = useToast();
  const { t } = useTranslation();
  const { data: account } = useMe(true);
  useLocale(account?.locale);

  const { mutateAsync: acceptInvitation } = useAcceptInvitation(token);

  const onAccept = useCallback(async () => {
    try {
      await acceptInvitation();
      window.location.replace('/');
    } catch (e) {
      toast.exception(e);
    }
  }, [acceptInvitation]);

  return (
    <div>
      <h2 className={classes.h2}>
        {t('joinOrganization.title', { name: invitation.organizationName })}
      </h2>
      {account?.id === invitation.account?.id ? (
        <>
          <p className={classes.question}>
            {t('joinOrganization.question', {
              name: invitation.organizationName,
            })}
          </p>
          <div className={classes.buttonLine}>
            <Button
              text={t('joinOrganization.ignore')}
              to="/"
              color="red"
              variant="transparent"
            />
            <Button text={t('joinOrganization.accept')} onClick={onAccept} />
          </div>
        </>
      ) : (
        <LoginContent defaultEmail={invitation.email} />
      )}
    </div>
  );
};
